import React from 'react';
import { useNavigate } from 'react-router-dom';
import { appname, applogo ,appnameonly} from "../variables";

export default function Header({ isLegal = false }) {
  const navigate = useNavigate();

  return (
    <header className="d-flex justify-content-between align-items-center mb-4 flex-shrink-0">
      <div 
        className="d-flex align-items-center gap-2" 
        style={{ cursor: 'pointer' }} 
        onClick={() => navigate('/')}
      >
        <img src={appnameonly} alt="logo" width="100%" height="40" />
      </div>
      <div className="d-flex gap-3">
        {isLegal ? (
          <button 
            className="btn btn-primary btn-sm rounded-pill px-4 fw-bold shadow-sm" 
            onClick={() => navigate('/')}
          >
            HOME
          </button>
        ) : (
          <>
            <button className="btn btn-sm text-white-50 fw-bold" onClick={() => navigate('/login')}>LOG IN</button>
            <button className="btn btn-primary btn-sm rounded-pill px-4 fw-bold shadow-sm" onClick={() => navigate('/register')}>SIGN UP FREE</button>
          </>
        )}
      </div>
    </header>
  );
}